<template>
  <div>
    <vx-card class="w-full mb-6">
      <div class="vx-row">
        <div class="vx-col xs:w-full sm:w-full md:w-1/3 lg:w-1/3 xl:w-1/3">
          <label>Module</label>
          <v-select ref="moduleDropdown" class="w-full mb-3" placeholder="Search / Select Module" :options="modules" v-model="moduleDropdown"  @input="clearStudents" @search:focus="clearStudents"></v-select>
        </div>
        <div class="self-center vx-col xs:w-full sm:w-full md:w-1/3 lg:w-1/3 xl:w-1/3">
            <label>Search Options</label>
            
            <div class="mb-4 info-next-to-checkcss vx-row">
              <vs-checkbox v-model="criteria.showOnlyEvaluated" color="success">Show Evaluated Students</vs-checkbox>
              <vx-tooltip 
                text='Only Students with status of Evaluated will be shown' 
                position="bottom"
                class="info-icon-on-module" 
                delay=".3s">
                <feather-icon
                    svgClasses="h-6 w-6"
                    class="p-2 cursor-pointer"
                    icon="InfoIcon"
                  >
                </feather-icon>
              </vx-tooltip>
            </div>
          </div>
        <div style="justify-content:center; display: flex;" class="self-center vx-col xs:w-full sm:w-full md:w-1/3 lg:w-1/3 xl:w-1/3">
          <vs-button id="search" :disabled="!moduleDropdown"  vs-align="center" class="shadow" icon-pack="feather" icon="icon-search" color="success" @click="listModuleStudents">Search</vs-button>
        </div>
      </div>
      <div v-show="!isStudentListHidden">
        <vs-divider>Students</vs-divider>
        <vs-table :sst="true" @search="handleSearch" @change-page="handleChangePage" stripe ref="studentTable" class="vs-con-loading__container" single @selected="handleSelectedStudent" pagination :max-items="pageSize" search :data="students" v-scroll-to="'#studentTasksCard'">
          <!-- @sort="handleSort" -->

          <template slot="thead">
            <vs-th sort-key="studentFullName">Name</vs-th>
            <vs-th sort-key="studentIdNumber">ID Number</vs-th>
            <vs-th sort-key="studentMobile">Mobile</vs-th>
            <vs-th sort-key="studentEmail">Email</vs-th>
            <vs-th sort-key="numQueries">Queries</vs-th>
            <vs-th sort-key="moduleStatusId">Status</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :data="student" :key="indextr" v-for="(student, indextr) in data">

              <vs-td :data="data[indextr].studentFullName">
                {{ student.studentFullName }}
              </vs-td>

              <vs-td :data="data[indextr].studentIdNumber">
                {{ student.studentIdNumber }}
              </vs-td>

              <vs-td :data="data[indextr].studentMobile">
                {{ student.studentMobile }}
              </vs-td>

              <vs-td :data="data[indextr].studentEmail">
                {{ student.studentEmail }}
              </vs-td>

              <vs-td :data="data[indextr].statusName">
                <vs-chip :color="getQueriesColor(student.numQueries)"><strong>{{ student.numQueries }}</strong></vs-chip>
              </vs-td>
              
              <vs-td :data="data[indextr].moduleStatusName">
                <vs-chip :color="getStudentStatusColor(student.moduleStatusId)"><strong>{{ student.moduleStatusName }}</strong></vs-chip>
              </vs-td>

            </vs-tr>
          </template>
        </vs-table>
      </div>
    </vx-card>
    <vx-card id="studentTasksCard" class="mb-6" :title="studentTasksCardTitle" v-show="!isStudentTasksListHidden">
      <vs-table ref="studentTaskTable" stripe class="vs-con-loading__container" single @selected="handleSelectedTask" pagination :max-items="tasksPerPage" search :data="studentTasks">
        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow">

          <!-- ITEMS PER PAGE -->
          <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
            <div class="p-4 border border-solid border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium" >
              <span class="mr-2">{{ currentTaskPage * tasksPerPage - (tasksPerPage - 1) }} - {{ studentTasks.length - currentTaskPage * tasksPerPage > 0 ? currentTaskPage * tasksPerPage : studentTasks.length }} of {{ studentTasks.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="tasksPerPage=10">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="tasksPerPage=15">
                <span>15</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="tasksPerPage=20">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="tasksPerPage=25">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="tasksPerPage=50">
                <span>50</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="tasksPerPage=100">
                <span>100</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>

          <div class="flex flex-wrap-reverse items-center">
            <div id="refresh-btn" class="p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-success border border-solid border-success" @click="refreshTasks">
              <feather-icon icon="RefreshCcwIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-success">Refresh</span>
            </div>
          </div>
        </div>

        <template slot="thead">
          <vs-th sort-key="taskDisplayId">Task Name</vs-th>
          <vs-th sort-key="taskType">Type</vs-th>
          <vs-th sort-key="completedDate">Date Completed</vs-th>
          <vs-th sort-key="statusName">Status</vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="task" :key="indextr" v-for="(task, indextr) in data">

            <vs-td :data="data[indextr].taskDisplayId">
              {{ task.taskDisplayId + " : " + task.taskName }}
            </vs-td>

            <vs-td :data="data[indextr].taskType">
              {{ task.taskType }}
            </vs-td>

            <vs-td :data="data[indextr].completedDate">
              {{ task.completedDate.replace("T", " ").split('.')[0] }}
            </vs-td>

            <vs-td :data="data[indextr].statusName">
              <vs-chip :color="getStatusColor(task.statusId)">{{task.statusDisplayName}}</vs-chip>
            </vs-td>

          </vs-tr>
        </template>
      </vs-table>
    </vx-card>
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  export default {
    components: {
      'v-select': vSelect
    },
    data() {
      return {
        pageSize: 10,
        moduleDropdown: 0,
        loadingColor:'#fff',
        selected: [],
        modulesPerPage: 10,
        studentsPerPage: 10,
        tasksPerPage: 10,
        isMounted: false,
        isStudentListHidden: true,
        isStudentTasksListHidden: true,
        modules: [],
        students: [],
        studentTasks: [],
        criteria: {
          pageSize: 0,
          pageNumber: 0,
          sortKey: "",
          sortOrder: "",
          searchPhrase: "",
          showInactive: false,
          showOnlyEvaluated:false,
        },
        formData: {
          id: 0,
          description: ""
        },
        mode: "",
        studentTasksCardTitle: "",
        counterDanger: false,
        selectedStudent: null
      }
    },
    computed: {
      currentModulePage() {
        if (this.isMounted) {
          return this.$refs.moduleDropdown.currentx;
        }
        return 0;
      },
      currentStudentPage() {
        if (this.isMounted) {
          return this.$refs.studentTable.currentx;
        }
        return 0;
      },
      currentTaskPage() {
        if (this.isMounted) {
          return this.$refs.studentTaskTable.currentx;
        }
        return 0;
      },
      isDisabled: function() {
        return !(this.formData.description);
      }
    },
    methods: {
      initValues() {
        this.formData.id = 0;
        this.formData.description = "";
        this.mode = "";
        this.isStudentListHidden = true;
        this.errors.clear();
      },
      getStatusName(name) {
        if(name == 'SurveyAssessed')
          return 'Assessed (survey)';
        else if(name == 'EvaluatorCommented')
          return 'Evaluated';
        else
          return name
      },
      getStudentStatusColor(status){
        switch (status) {
          case 15:
            return 'warning'
            break;
          case 16:
            return 'success'
            break;
          default:
            return 'danger'
            break;
        }
      },
      getStatusColor(statusId) {
        if(statusId == 15)
          return 'success';
        else if(statusId == 3 || statusId == 20)
          return 'danger';
        else if(statusId == 19 || statusId == 14)
          return 'warning';
        else{
          return 'success'
        }
      },
      getQueriesColor(numQueries) {
        var self = this;
        if(numQueries == 0)
          return 'success';
        else
          return 'danger';
      },
      cancelAdd() {
        this.initValues();
        this.isStudentListHidden = true;
      },
      handleSelectedModule(mod) {
        const self = this;
        self.isStudentListHidden = false;
        self.showLoadingOnElement("studentTable", 1, "corners");

        var onSuccess = function (response) {
          self.students = response.data;
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.studentTable.$el);
        };

        self.$ajaxGet(self, "Evaluator/ListModuleStudentsSst?moduleId=" + mod.id, onSuccess, onFinally);
      },
      saveData() {
        this.initValues();
        this.loadData();
        this.$vs.loading.close(this.$refs.saveEditButton.$el);
      },
      loadModules() {
        const self = this;
        self.showLoadingOnElement("moduleDropdown", 0.45, "corners");

        var onSuccess = function (response) {
          self.modules = response.data.map((item) => { return { label: item.text, value: item.value } });
        };

        var onFinally = function () {
          self.$vs.loading.close(self.$refs.moduleDropdown.$el);
        };

        self.$ajaxGet(self, "Evaluator/GetEvaluatorModules", onSuccess, onFinally);
      },
      clearStudents() {
        var self = this;
        self.students = [];
        self.isStudentListHidden = true;
        self.studentTasks = [];
        self.isStudentTasksListHidden = true;
      },
      handleSelectedStudent(student) {
        var self = this;
        self.selectedStudent = student;
        self.studentTasksCardTitle = "Tasks for " + student.studentFullName;
        self.isStudentTasksListHidden = false;
        self.showLoadingOnElement("studentTaskTable", 1, "corners");

        var onSuccess = function (response) {
          self.studentTasks = response.data;
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.studentTaskTable.$el);
        };

        self.$ajaxGet(self, "Evaluator/ListStudentTasks?studentId=" + student.studentId + "&moduleId=" + student.moduleId, onSuccess, onFinally);
      },
      listModuleStudents() {
        const self = this;
        if (self.moduleDropdown) {
          self.isStudentListHidden = false;
          self.showLoadingOnElement("studentTable", 1, "corners");

          var onSuccess = function (response) {
            self.students = [];

            if (self.criteria.pageNumber > 1)
              self.students[((self.criteria.pageNumber - 1) * self.pageSize) - 1] = {};

            self.students = self.students.concat(response.data.records);

            if (response.data.count > (self.criteria.pageNumber * self.pageSize))
              self.students[response.data.count - 1] = {};
          };
          var onFinally = function () {
            self.$vs.loading.close(self.$refs.studentTable.$el);
          };

          self.$ajaxPost(self, "Evaluator/ListModuleStudentsSst?moduleId=" + self.moduleDropdown.value, self.criteria, onSuccess, onFinally);
        }
      },
      refreshTasks() {
        var self = this;
        self.showLoadingOnElement("studentTaskTable", 1, "corners");

        var onSuccess = function (response) {
          self.studentTasks = response.data;
        };
        var onFinally = function () {
          self.$vs.loading.close(self.$refs.studentTaskTable.$el);
        };

        self.$ajaxGet(self, "Evaluator/ListStudentTasks?studentId=" + self.selectedStudent.studentId + "&moduleId=" + self.selectedStudent.moduleId, onSuccess, onFinally);
      },
      handleSelectedTask(task) {
        var self = this;
        self.showLoadingOnElement("studentTaskTable", 1, "corners");

        var onSuccess = function(response){
          if(response.data === true){
            let routeData = self.$router.resolve({ path: 'evaluator/ViewTask', query: { TaskLogId: task.logId } });
            window.open(routeData.href, '_blank');
          }
        }

        var onFinally = function(){
         self.$vs.loading.close(self.$refs.studentTaskTable.$el);
        }

        self.$ajaxPost(self, "Evaluator/AssignTask?id=" + task.logId, null, onSuccess, onFinally);
      },
      showLoadingOnElement(element, scale, type){
        var self = this;
        self.$vs.loading({
          type: type,
          container: self.$refs[element].$el,
          scale: scale
        });
      },
      scrollToNavbar() {
        var scrollOptions = {
          easing: 'ease-in',
          offset: -500,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        var cancelScroll = this.$scrollTo(document.getElementById("navbarGlobal"), 500, scrollOptions);
      },

    handleSearch(searchPhrase) {
      var self = this;

      if (searchPhrase.length >= 3) {
        self.criteria.searchPhrase = searchPhrase;

        self.listModuleStudents();
      }
      else if (searchPhrase == "") {
        self.criteria.searchPhrase = searchPhrase;
        self.listModuleStudents();
      }
    },
    handleChangePage(pageNumber) {
      var self = this;

      if (pageNumber > 0) {
        self.criteria.pageNumber = pageNumber;

        self.listModuleStudents();
      }
    },
  },
 mounted() {
    var self = this;
    self.loadModules();
    self.criteria.pageSize = self.pageSize;
    self.criteria.pageNumber = self.$refs.studentTable.currentPage;
    self.isMounted = true;
  },
  }

</script>
<style lang='scss'>

</style>
